import { render } from "./UclStages.vue?vue&type=template&id=167c8a31"
import script from "./UclStages.vue?vue&type=script&lang=js"
export * from "./UclStages.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\abscu\\OneDrive\\Desktop\\htmlcss\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__